import { defineStore } from "pinia";


export const useHuaShuSore = defineStore("huashu", {
  state: () => ({
    lineType: '2',
    sysType:'2',
    huashuInfo: JSON.parse(localStorage.getItem('huashuInfo')) || {},
  }),
  getters: {
    testGetters(state) {
      // 自动补全！ ✨
      return state.testState;
    },
  },
  actions: {

  },
});

